import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    statusVerificationItems: {count: 0, rows: []},
    loading: false,
    checkDelete: {},
};

const requestStatusVerificationItemsStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchStatusVerificationItemsSuccess = ( state, action ) => {
    return updateObject( state, {
        statusVerificationItems: action.statusVerificationItems,
        loading: false
    } );
};

const requestStatusVerificationItemsFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};

const deleteStatusVerificationItemsSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const checkDeleteStatusVerificationItemsSuccess = (state, action) => {
  return updateObject(state, { 
    checkDelete: action.checkDelete,
    loading: false 
  });
}

const updateStatusVerificationItemsSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const postStatusVerificationItemsSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.REQUEST_STATUS_VERIFICATION_ITEMS_START: return requestStatusVerificationItemsStart( state, action );
        case actionTypes.FETCH_STATUS_VERIFICATION_ITEMS_SUCCESS: return fetchStatusVerificationItemsSuccess( state, action );
        case actionTypes.REQUEST_STATUS_VERIFICATION_ITEMS_FAIL: return requestStatusVerificationItemsFail( state, action );
        case actionTypes.DELETE_STATUS_VERIFICATION_ITEMS_SUCCESS: return deleteStatusVerificationItemsSuccess( state, action );
        case actionTypes.CHECK_DELETE_STATUS_VERIFICATION_ITEMS_SUCCESS: return checkDeleteStatusVerificationItemsSuccess(state, action);
        case actionTypes.UPDATE_STATUS_VERIFICATION_ITEMS_SUCCESS: return updateStatusVerificationItemsSuccess( state, action );
        case actionTypes.POST_STATUS_VERIFICATION_ITEMS_SUCCESS: return postStatusVerificationItemsSuccess( state, action );

        default: return state;
    }
};

export default reducer;